import {atom, selector} from 'recoil';
import {config} from '../config/config-chancer-development';

export const visibilityState = atom({
  key: 'visibilityState',
  default: true,
});

export const configState = atom({
  key: 'configState',
  default: config,
});

export const protocolState = selector({
  key: 'protocolState',
  get: ({get}) => {
    const config = get(configState);
    return config.environment === 'local' ? 'http:' : 'https:';
  },
});

export const adminOriginState = selector({
  key: 'adminOriginState',
  get: ({get}) => {
    const config = get(configState);
    return config.environment === 'local'
      ? `http://${config.adminDomain}`
      : window.location.origin;
  },
});

export const manageQuestionsOpen = atom<
  Record<string, Record<string, boolean>>
>({
  key: 'manageQuestionsOpen',
  default: {},
});
